import React from "react";
import clsx from "clsx";
import Footer from "./Footer/Footer";

type Props = {
	children: React.ReactNode;
	className?: string;
};

const PageLayout = ({ className, children }: Props) => (
	// Sticky footer: fill the viewport below the app header (60px mobile / 76px
	// lg) and let the content area grow, so the footer is pinned to the bottom
	// even when a page's content is short — no white gap below it, no float.
	<div
		className={clsx(
			"bg-white flex min-h-[calc(100vh-60px)] flex-col lg:min-h-[calc(100vh-76px)]",
			className,
		)}
	>
		<div className="flex flex-1 flex-col">{children}</div>
		<Footer />
	</div>
);

export default PageLayout;
